<template>
    <div class="mobile-sign-page">
        <div v-if="!done" class="sign-body">
            <MobileSignaturePad
                :uuid="uuid"
                :token="token"
                @signed="onSigned" />
        </div>
        <div v-else class="sign-receipt">
            <i class="el-icon-success"></i>
            <p>{{ $t("signature.done") }}</p>
        </div>
    </div>
</template>

<script>
import MobileSignaturePad from "@/components/signature/MobileSignaturePad.vue";

export default {
    name: "MobileSignPage",
    components: { MobileSignaturePad },
    data() {
        return {
            uuid: this.$route.query.uuid || null,
            token: this.$route.query.token || null,
            done: false
        };
    },
    created() {
        this.setChrome(false);
    },
    beforeDestroy() {
        this.setChrome(true);
    },
    methods: {
        setChrome(visible) {
            this.$store.commit("base/setShowHeader", visible, { root: true });
            this.$store.commit("base/setShowSidebar", visible, { root: true });
        },
        onSigned(result) {
            this.done = true;
            this.$emit("signed", result);
            // 本页现在只服务「扫码用另一台手机签」这一条链路：原页面靠轮询感知结果，
            // 这里只展示完成提示，不再尝试 window.close()——扫码打开的标签页没有 opener，
            // 脚本关不掉，用户只会看到一个关不上的页面。
            // （同浏览器另开标签页的场景仍可能存在，顺手写一条 localStorage 通知让原页面立刻感知。）
            try {
                localStorage.setItem(
                    "mmf_signature_done",
                    JSON.stringify({ uuid: (result && result.uuid) || this.uuid, ts: Date.now() })
                );
            } catch (e) {
                // localStorage 不可用时忽略，原页面轮询兜底
            }
        }
    }
};
</script>

<style scoped>
.mobile-sign-page {
    position: fixed;
    inset: 0;
    background: #f5f6f8;
    display: flex;
    flex-direction: column;
}
.sign-body {
    flex: 1;
}
.sign-receipt {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #52c41a;
}
.sign-receipt i {
    font-size: 64px;
}
</style>
